var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-expansion-panels"},_vm._l((_vm.list),function(item,i){return _c('BaseExpansionPanelOld',{key:i,attrs:{"is-html":_vm.isHtml,"flat":_vm.flat,"header":item.question,"content":item.answer,"force-expand":item.expand,"handle-type":"manuel"},on:{"toggleExpand":function($event){
var i$1 = arguments.length, argsArray = Array(i$1);
while ( i$1-- ) argsArray[i$1] = arguments[i$1];
return _vm.toggleExpand.apply(void 0, [ i ].concat( argsArray ))}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }